import React from 'react'
import styled from 'styled-components'
import '../components/theme.js'

const SectionCard = styled.div`
    height:240px;
    max-width:100%;
    background:var(--White);
    border:0.5px solid var(--GrayLevel6);
    border-radius:24px;
    display:grid;
    overflow:hidden;
    box-shadow:0px 8px 24px rgba(0,0,0,0.03);
    transition: 1s cubic-bezier(0.15, 0.1, 0.1, 1);

    &:hover{
        transform:scale(1.05,1.05);
        box-shadow:0 6px 24px rgba(0,0,0,0.05);
        cursor:pointer;
    }
    `

 const BlogBase = styled.div`
    display:grid;
    grid-template-rows:80px auto;
    position:relative;
    overflow:hidden;
    `


const SectionCover = styled.img`
    position:absolute;
    height:64px;
    width:64px;
    margin:16px;
    border-radius:12px;
    box-shadow:0px 6px 20px rgba(0,0,0,0.08);
    `
const BlogHeader= styled.div`
    max-width:400px;
    display:grid;
    grid-template-rows:repeat(2,1fr)
    `

const BlogInfo = styled.div`
    margin-left:96px;
    margin-top:15px;
    width:72px;
    justify-items:center;
    align-items:center;
    display:grid;
    grid-template-columns:repeat(2,1fr);
    grid-gap:8px;`

const SectionTitle = styled.h3`
    font-size:2em;
    margin-left:96px;
    margin-top:-8px;
    color:var(--GrayLevel1);
`

const SectionLogo = styled.img`
    height:16px;
    width:16px;
    border-radius:12px;`

const SectionTime = styled.p`
    color:var(--GrayLevel3);`

const SectionDescription = styled.h4`
    margin:0px 16px;
    align-items:center;
    justify-items:center;
    color:var(--GrayLevel2)`

const SectionContent = styled.p`
    align-self:top;
    color:var(--GrayLevel3);
    line-height:1.6;
    letter-spacing:0.2px;
    margin:0px 16px;`

const Card = props =>(
    <div className="CardInfo">
        <SectionCard>
            <BlogBase>
                <SectionCover src={props.img} />
                <BlogHeader>
                    <BlogInfo>
                        <SectionLogo src={props.avatar}/>
                        <SectionTime>{props.datatime}</SectionTime>
                    </BlogInfo>
                    <SectionTitle>{props.title}</SectionTitle>
                </BlogHeader>
            </BlogBase>            
            <SectionDescription>{props.subtitle}</SectionDescription>
            <SectionContent>{props.text}</SectionContent>
        </SectionCard>
        </div>
)

export default Card